export const trackEvent = (eventName: string, params: Record<string, any> = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, params);
  }
};

export const trackPageView = (pagePath: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-73YNSQV9K0', {
      page_path: pagePath
    });
  }
};
